/**
 * API de cambios de plan base / escalón comercial diferidos al período
 * siguiente (Panel → coofit_core.tenant_plan_change).
 */

import { httpClient } from '../http/client/httpClient';

export type PlanChangeTipo =
  | 'PLAN_BASE'
  | 'COOFIT_CONEXION'
  | 'COOFIT_MARKETING'
  | 'COOFIT_WHATSAPP_BOT';

export type PlanChangeEstado = 'pendiente' | 'aplicado' | 'cancelado';

export interface PlanChangeDTO {
  id: number;
  tenantId: string;
  tipo: PlanChangeTipo;
  valorActualId: number | null;
  valorNuevoId: number | null;
  fechaEfectiva: string;
  estado: PlanChangeEstado;
  forzadoInmediato: boolean;
  motivo: string | null;
  creadoEn: string;
  creadoPor: string | null;
  aplicadoEn: string | null;
  canceladoEn: string | null;
  canceladoPor: string | null;
}

export interface ScheduleOrApplyResult {
  status: 'aplicado_inmediato' | 'programado';
  pendingChange: PlanChangeDTO | null;
}

function apiErrorMessage(err: unknown, fallback: string): Error {
  if (err && typeof err === 'object' && 'response' in err) {
    const data = (err as { response?: { data?: { message?: string } } }).response?.data;
    if (data?.message) return new Error(data.message);
  }
  if (err instanceof Error) return err;
  return new Error(fallback);
}

export async function listPendingPlanChanges(tenantId: string): Promise<PlanChangeDTO[]> {
  try {
    const response = await httpClient.get<PlanChangeDTO[]>(`/admin/tenants/${tenantId}/plan-changes`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (err) {
    throw apiErrorMessage(err, 'No se pudieron cargar los cambios de plan pendientes');
  }
}

export async function schedulePlanChange(
  tenantId: string,
  body: {
    tipo: PlanChangeTipo;
    valorNuevoId: number | null;
    forzarInmediato?: boolean;
    motivo?: string;
  }
): Promise<ScheduleOrApplyResult> {
  try {
    const response = await httpClient.post<ScheduleOrApplyResult>(
      `/admin/tenants/${tenantId}/plan-changes`,
      body
    );
    return response.data;
  } catch (err) {
    throw apiErrorMessage(err, 'No se pudo aplicar/programar el cambio de plan');
  }
}

export async function cancelPlanChange(tenantId: string, id: number): Promise<PlanChangeDTO> {
  try {
    const response = await httpClient.post<PlanChangeDTO>(
      `/admin/tenants/${tenantId}/plan-changes/${id}/cancel`
    );
    return response.data;
  } catch (err) {
    throw apiErrorMessage(err, 'No se pudo cancelar el cambio programado');
  }
}
